module.exports = __webpack_public_path__ + "img/flexsale-refined-7.cddaa75d.png";